<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <div style="background: #fff; padding-left: 16px; height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex; margin-top: 10px">
              <a-input-search
                v-model="searchAreaValue"
                style="width: 100%; margin-right: 5px"
                allowClear
                :placeholder="$t('请输入区域名称')"
              />
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    @node-click="nodeClick"
                    ref="areaTree"
                  >
                  </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <!-- class="new-table-card" -->
      <a-card :bordered="false">
        <a-tabs v-model="activeKey" @change="changeTab">
            <a-tab-pane key="1" :tab="$t('全部')">
                <allIndex ref="allIndexRef"></allIndex>
            </a-tab-pane>
            <a-tab-pane key="2" :tab="$t('告警')">
                <alarmIndex ref="alarmIndexRef"></alarmIndex>
            </a-tab-pane>
            <a-tab-pane key="3" :tab="$t('不上报')">
                <notReportIndex ref="notReportIndexRef"></notReportIndex>
            </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { getAction, deleteAction, postAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import configService from '@/utils/service/config.service'
import { listSize } from '@/utils/util'
import Vue from 'vue'
import allIndex from './allIndex.vue'
import alarmIndex from './alarmIndex.vue'
import notReportIndex from './notReportIndex.vue'
export default {
  name: 'LargeUserMonitoring',
  mixins: [JeecgListMixin,mixinDevice, AreaChoosetMixin, TableDragResize],
  components: {
    JInput,
    allIndex,
    alarmIndex,
    notReportIndex
  },
  data() {
    return {
      //表头
      columns: [],
      collapsed: false,
      data: [],
      visible: false,
      url: {
        list: '/jeecg-charge/meter/meterUserinfo/list',
      },
      activeKey: '1',
    }
  },
  computed: {},
  methods: {
    changeTab(e){
        switch(e) {
          case '1':
            this.$nextTick(()=>{
              this.$refs.allIndexRef.init(this.queryParam);
            })
            break;
          case '2':
            this.$nextTick(()=>{
              this.$refs.alarmIndexRef.init(this.queryParam);
            })
            break;
          case '3':
            this.$nextTick(()=>{
              this.$refs.notReportIndexRef.init(this.queryParam);
            })
            break;
        }
    },
    nodeClick(record, node, data) {
      console.log(record)
      console.log(node)
      console.log(data)
      // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
      if (node.checked) {
        this.currentNodeKey = record.id
        this.$refs.areaTree.setCheckedKeys([record.id])
        this.currSelected = Object.assign({}, record)
        // 有的接口是areaId有的接口是userAreaId，兼容两个都写
        this.queryParam.areaCode = this.currSelected.id
      } else {
        this.currentNodeKey = null
        this.currSelected = {}
        this.$refs.areaTree.setCheckedKeys([])
        // 有的接口是areaId有的接口是userAreaId，兼容两个都写
        delete this.queryParam.areaCode
      }
      switch(this.activeKey) {
        case '1':
          this.$nextTick(()=>{
            this.$refs.allIndexRef.init(this.queryParam);
          })
          break;
        case '2':
          this.$nextTick(()=>{
            this.$refs.alarmIndexRef.init(this.queryParam);
          })
          break;
        case '3':
          this.$nextTick(()=>{
            this.$refs.notReportIndexRef.init(this.queryParam);
          })
          break;
      }
    },
    resetAareaData() {
      console.log('areaChoose')
      this.hiding = true
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
      delete this.queryParam.areaCode
      if (this.rootOpened) {
        this.setThisExpandedKeys(this.areaTree)
      }

      // 20220228修改的
      this.currentNodeKey = null
      if (this.$refs.areaTree) {
        this.$refs.areaTree.setCheckedKeys([])
      }
      switch(this.activeKey) {
        case '1':
          this.$nextTick(()=>{
            this.$refs.allIndexRef.init({areaCode:''});
          })
          break;
        case '2':
          this.$nextTick(()=>{
            this.$refs.alarmIndexRef.init({areaCode:''});
          })
          break;
        case '3':
          this.$nextTick(()=>{
            this.$refs.notReportIndexRef.init({areaCode:''});
          })
          break;
      }
    },
  },
  created() {
    // this.$store.commit('SET_LAYOUT_TREE', true)
  },
  mounted() {
    this.$refs.allIndexRef.init();
  },
}
</script>
<style scoped lang="less">
.drawer-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.qrcodeInfo {
  color: #222;
  margin: 5px 0;
}
</style>
<style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
</style>
<style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
::v-deep .ant-tabs .ant-tabs-top-content, 
::v-deep .ant-tabs .ant-tabs-bottom-content{
    height: calc(100% - 60px);
}
::v-deep .ant-tabs{
  height: 100%;
}
</style>